// assets
import { IconLogout } from "@tabler/icons-react";

// constant
const icons = { IconLogout };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const logoutMenu = {
  id: "logout",
  title: "Logout",
  type: "item",
  url: `${process.env.REACT_APP_DUKE_BASE_URL}/user/oauth20/signout?client_id=${process.env.REACT_APP_DUKE_CLIENT_ID}&RelayState=AnyStateFromClient`,
  icon: icons.IconLogout,
  breadcrumbs: false,
  external: true,
};

export default logoutMenu;
